import axios from "axios";
import { getTenantId } from "../components/shared/util";

let shouldRetryAuthErrorHandler = null;
let refreshSessionHandler = null;
let refreshFailureHandler = null;

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

// Add a request interceptor
apiClient.interceptors.request.use((config) => {
  const tenantid = getTenantId();

  if (tenantid) {
    config.headers.tenantId = tenantid;
  }

  return config;
});

// Add a response interceptor
apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error?.config;

    if (
      !originalRequest ||
      originalRequest._retry ||
      originalRequest._skipAuthRefresh ||
      typeof refreshSessionHandler !== "function"
    ) {
      return Promise.reject(error);
    }

    const shouldRetryAuthError =
      typeof shouldRetryAuthErrorHandler === "function" &&
      shouldRetryAuthErrorHandler(error);

    if (!shouldRetryAuthError) {
      return Promise.reject(error);
    }

    originalRequest._retry = true;

    try {
      await refreshSessionHandler({
        reason: "axios-response",
        request: originalRequest,
      });
      return apiClient(originalRequest);
    } catch (refreshError) {
      if (typeof refreshFailureHandler === "function") {
        refreshFailureHandler(refreshError, {
          originalError: error,
          request: originalRequest,
        });
      }

      return Promise.reject(refreshError);
    }
  },
);

export const configureApiClientAuth = ({
  shouldRetryAuthError,
  refreshSession,
  onRefreshFailure,
} = {}) => {
  shouldRetryAuthErrorHandler =
    typeof shouldRetryAuthError === "function" ? shouldRetryAuthError : null;
  refreshSessionHandler =
    typeof refreshSession === "function" ? refreshSession : null;
  refreshFailureHandler =
    typeof onRefreshFailure === "function" ? onRefreshFailure : null;
};

export default apiClient;
